import React from 'react'
import tw from 'tailwind-styled-components'
import {TriCheckboxNew} from '@components/common/base/checkbox-new'
import {Icon} from '@components/common/base/icon'
import {OptionsItemCheckbox} from './types'

interface DropdownMenuItemCheckboxProps {
  item: OptionsItemCheckbox
  size?: '32' | '36' | '40'
  onToggle?: (item: OptionsItemCheckbox) => void
}

export const DropdownMenuItemCheckbox = ({
  item,
  onToggle,
  size = '32'
}: DropdownMenuItemCheckboxProps) => (
  <TwItemContainer
    $selected={item.selected}
    $size={size}
    onClick={() => onToggle?.(item)}
  >
    <TriCheckboxNew value={item.selected} />
    {item.icon && <Icon icon={item.icon} />}
    <TwItemLabel $content={!!item.content}>
      {item.content ?? item.text}
    </TwItemLabel>
  </TwItemContainer>
)

const TwItemLabel = tw.div<{$content?: boolean}>`
  flex-1
  min-w-0
  text-primary
  text-sm-regular
  ${p => (p.$content ? 'flex' : 'truncate')}
`

const TwItemContainer = tw.div<{
  $selected?: boolean
  $size: '32' | '36' | '40'
}>`
  flex
  flex-row
  items-center
  gap-8
  truncate

  px-12
  py-8
  select-none

  hover:bg-interactive-l100
  active:bg-interactive-l80

  ${p => {
    if (p.$size === '32') {
      return 'h-32'
    }
    if (p.$size === '36') {
      return 'h-36'
    }
    if (p.$size === '40') {
      return 'h-40'
    }
    return 'h-32'
  }}
`
